//npx svgr --icon --replace-attr-values "#000=currentColor" Workspace_Icon.svg
import SvgCogIcon from "./CogIcon";
import SvgHomeIcon from "./HomeIcon";
import SvgWorkspaceIcon from "./WorkspaceIcon";
import SvgClientIcon from "./ClientIcon";
import SvgCreateIcon from "./CreateIcon";
import SvgEditIcon from "./EditIcon";
import SvgNoteIcon from "./NoteIcon";
import SvgTagIcon from "./TagIcon";
import SvgWarehouseIcon from "./WarehouseIcon";
import SvgUnitIcon from "./UnitIcon";
import SvgItemIcon from "./ItemIcon";
import SvgLogOutIcon from "./LogOutIcon";
import SvgLogInIcon from "./LogInIcon";
import SvgApplyIcon from "./ApplyIcon";
import SvgDeleteIcon from "./DeleteIcon";
import SvgEyeIcon from "./EyeIcon";
import SvgEyeCrossedIcon from "./EyeCrossedIcon";
import SvgRefreshIcon from "./RefreshIcon";
import SvgAnnouncementIcon from "./AnnouncementIcon";
import SvgSortIcon from "./SortIcon";
import SvgFilterIcon from "./FilterIcon";
import SvgArrowIcon from "./ArrowIcon";
import SvgDataIcon from "./DataIcon";

function GetSvgIcon(type) {
  const icons = {
    cog: SvgCogIcon,
    home: SvgHomeIcon,
    workspace: SvgWorkspaceIcon,
    warehouse: SvgWarehouseIcon,
    item: SvgItemIcon,
    tag: SvgTagIcon,
    client: SvgClientIcon,
    unit: SvgUnitIcon,
    note: SvgNoteIcon,
    edit: SvgEditIcon,
    create: SvgCreateIcon,
    login: SvgLogInIcon,
    logout: SvgLogOutIcon,
    apply: SvgApplyIcon,
    delete: SvgDeleteIcon,
    eye: SvgEyeIcon,
    eyeCrossed: SvgEyeCrossedIcon,
    refresh: SvgRefreshIcon,
    announcement: SvgAnnouncementIcon,
    sort: SvgSortIcon,
    filter: SvgFilterIcon,
    arrow: SvgArrowIcon,
    data: SvgDataIcon,
  };
  return icons[type] || null;
}
export default GetSvgIcon;
